<template>
  <div class="member-container">
    <el-card class="member-card" shadow="never">
      <template #header>
        <span>VIP与充值管理</span>
      </template>

      <!-- 手机号查找区域 -->
      <div style="margin-bottom: 20px;">
        <el-form :model="searchForm" inline>
          <el-form-item label="用户手机号">
            <el-input v-model="searchForm.phone" placeholder="请输入用户手机号" clearable style="width: 250px;" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="searching" @click="searchUser">查找用户</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 用户列表 -->
      <el-table :data="userList" border class="member-table" table-layout="fixed">
        <el-table-column prop="phone" label="手机号" width="150" />
        <el-table-column prop="password" label="密码" width="120" />
        <el-table-column prop="invitation" label="邀请码" width="120" />
        <el-table-column prop="points" label="积分余额" width="130" />
        <el-table-column prop="vip" label="会员类型" width="150">
          <template #default="{ row }">
            <el-tag :type="row.currentMemberType !== '非会员' ? 'success' : 'info'">
              {{ row.currentMemberType }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="expireTime" label="到期时间" width="200" />
        <el-table-column prop="CreateTime" label="注册时间" width="180" />
        <el-table-column label="操作" min-width="480" fixed="right">
          <template #default="scope">
            <el-button size="small" type="primary" @click="openMemberDialog(scope.row)">
              开通会员
            </el-button>
            <el-button size="small" type="warning" @click="openPwdDialog(scope.row)" style="margin-left: 8px;">
              修改密码
            </el-button>
            <el-button size="small" type="info" @click="openInviteDialog(scope.row)" style="margin-left: 8px;">
              修改邀请码
            </el-button>
            <el-button size="small" type="success" @click="openPointsDialog(scope.row)" style="margin-left: 8px;">
              积分调整
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 开通会员弹窗 -->
      <el-dialog v-model="dialogVisible" title="开通/续费会员" width="460px" append-to-body
        :lock-scroll="false" destroy-on-close>
        <el-form :model="memberForm" ref="memberFormRef" :rules="formRules">
          <el-form-item label="用户手机号" prop="phone">
            <el-input v-model="memberForm.phone" disabled />
          </el-form-item>
          <el-form-item label="用户姓名" prop="name">
            <el-input v-model="memberForm.name" disabled />
          </el-form-item>
          <el-form-item label="当前到期时间">
            <el-input v-model="memberForm.currentExpireTime" disabled />
          </el-form-item>
          <el-form-item label="开通天数" prop="days">
            <el-input-number v-model="memberForm.days" :min="1" :step="1" step-strictly controls-position="right"
              style="width: 100%;" />
            <div class="form-tip">支持输入任意正整数天数；未到期用户将在原到期时间上续期。</div>
          </el-form-item>
          <el-form-item label="预计到期时间">
            <el-input v-model="memberForm.expireTime" disabled />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmOpenMember">确认开通</el-button>
        </template>
      </el-dialog>

      <!-- 修改密码弹窗 -->
      <el-dialog v-model="pwdDialogVisible" title="修改用户密码" width="400px" append-to-body
        :lock-scroll="false" destroy-on-close>
        <el-form :model="pwdForm" ref="pwdFormRef" :rules="pwdRules">
          <el-form-item label="用户手机号" prop="phone">
            <el-input v-model="pwdForm.phone" disabled />
          </el-form-item>
          <el-form-item label="新密码" prop="newPwd">
            <el-input v-model="pwdForm.newPwd" type="password" placeholder="请输入6位以上密码" show-password />
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPwd">
            <el-input v-model="pwdForm.confirmPwd" type="password" placeholder="请再次输入新密码" show-password />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="pwdDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmUpdatePwd">确认修改</el-button>
        </template>
      </el-dialog>

      <!-- 修改邀请码弹窗 -->
      <el-dialog v-model="inviteDialogVisible" title="修改用户邀请码" width="400px" append-to-body
        :lock-scroll="false" destroy-on-close>
        <el-form :model="inviteForm" ref="inviteFormRef" :rules="inviteRules">
          <el-form-item label="用户手机号" prop="phone">
            <el-input v-model="inviteForm.phone" disabled />
          </el-form-item>
          <el-form-item label="原邀请码" prop="oldInvite">
            <el-input v-model="inviteForm.oldInvite" disabled />
          </el-form-item>
          <el-form-item label="新邀请码" prop="newInvite">
            <el-input v-model="inviteForm.newInvite" placeholder="请输入新的邀请码" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="inviteDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmUpdateInvite">确认修改</el-button>
        </template>
      </el-dialog>

      <!-- 积分充值/扣除弹窗 -->
      <el-dialog v-model="pointsDialogVisible" title="积分调整" width="460px" append-to-body
        :lock-scroll="false" destroy-on-close>
        <el-form :model="pointsForm" ref="pointsFormRef" :rules="pointsRules" label-width="100px">
          <el-form-item label="用户手机号" prop="phone">
            <el-input v-model="pointsForm.phone" disabled />
          </el-form-item>
          <el-form-item label="当前积分">
            <el-input v-model="pointsForm.currentPoints" disabled />
          </el-form-item>
          <el-form-item label="操作类型" prop="operation">
            <el-radio-group v-model="pointsForm.operation">
              <el-radio-button label="add">充值积分</el-radio-button>
              <el-radio-button label="deduct">扣除积分</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="积分数量" prop="amount">
            <el-input-number v-model="pointsForm.amount" :min="0.01" :precision="2" :step="100"
              controls-position="right" style="width: 100%;" />
          </el-form-item>
          <el-form-item label="调整后积分">
            <el-input :model-value="pointsAfterAdjustment" disabled />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="pointsDialogVisible = false">取消</el-button>
          <el-button :type="pointsForm.operation === 'deduct' ? 'danger' : 'primary'" @click="confirmAdjustPoints">
            确认{{ pointsForm.operation === 'deduct' ? '扣除' : '充值' }}
          </el-button>
        </template>
      </el-dialog>

    </el-card>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import axios from "axios";
import dayjs from "dayjs";

// 会员类型映射（数字→名称）
const vipTypeMap = {
  0: '非会员',
  4: '试用会员',
  1: '会员',
  3: '年卡',
  6: '终身'
};

// 搜索表单
const searchForm = reactive({
  phone: ""
});

// 用户列表
const userList = ref([]);
const searching = ref(false);

// 开通会员弹窗相关
const dialogVisible = ref(false);
const currentUser = ref(null);
const memberFormRef = ref(null);
const memberForm = reactive({
  phone: "",
  name: "",
  currentExpireTime: "无",
  days: 30,
  expireTime: ""
});
const formRules = reactive({
  days: [
    { required: true, message: "请输入会员天数", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (!Number.isSafeInteger(Number(value)) || Number(value) <= 0) {
          callback(new Error("会员天数必须是大于0的整数"));
        } else {
          callback();
        }
      },
      trigger: ["blur", "change"]
    }
  ]
});

// 修改密码弹窗相关
const pwdDialogVisible = ref(false);
const pwdFormRef = ref(null);
const pwdForm = reactive({
  phone: "",
  newPwd: "",
  confirmPwd: ""
});
const pwdRules = reactive({
  newPwd: [
    { required: true, message: "请输入新密码", trigger: "blur" },
    { min: 6, message: "密码长度不能少于6位", trigger: "blur" }
  ],
  confirmPwd: [
    { required: true, message: "请确认新密码", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (value !== pwdForm.newPwd) {
          callback(new Error("两次输入的密码不一致"));
        } else {
          callback();
        }
      },
      trigger: "blur"
    }
  ]
});

// 修改邀请码弹窗相关
const inviteDialogVisible = ref(false);
const inviteFormRef = ref(null);
const inviteForm = reactive({
  phone: "",
  oldInvite: "",
  newInvite: ""
});
const inviteRules = reactive({
  newInvite: [
    { required: true, message: "请输入新邀请码", trigger: "blur" },
    { min: 6, max: 20, message: "邀请码长度需在6-20位之间", trigger: "blur" }
  ]
});

// 积分充值/扣除弹窗
const pointsDialogVisible = ref(false);
const pointsFormRef = ref(null);
const pointsForm = reactive({
  phone: "",
  currentPoints: 0,
  operation: "add",
  amount: 100
});
const pointsRules = reactive({
  operation: [{ required: true, message: "请选择操作类型", trigger: "change" }],
  amount: [
    { required: true, message: "请输入积分数量", trigger: ["blur", "change"] },
    {
      validator: (rule, value, callback) => {
        const num = Number(value);
        if (!Number.isFinite(num) || num <= 0) {
          callback(new Error("积分数量必须大于0"));
        } else {
          callback();
        }
      },
      trigger: ["blur", "change"]
    }
  ]
});

const pointsAfterAdjustment = computed(() => {
  const current = Number(pointsForm.currentPoints || 0);
  const amount = Number(pointsForm.amount || 0);
  return pointsForm.operation === "deduct" ? current - amount : current + amount;
});

// 未到期会员从当前到期时间续期，已过期用户从现在开始计算。
watch(() => memberForm.days, (days) => {
  const currentExpire = currentUser.value?.vipTimeRaw;
  let base = dayjs();
  if (currentExpire && dayjs(currentExpire).isValid() && dayjs(currentExpire).isAfter(dayjs())) {
    base = dayjs(currentExpire);
  }
  memberForm.expireTime = Number(days) > 0
    ? base.add(Number(days), "day").format("YYYY-MM-DD HH:mm:ss")
    : "";
});

const errorText = (value, fallback = "操作失败") => {
  if (typeof value === "string") return value;
  return value?.message || fallback;
};

// 从服务器获取用户数据（抽离复用）
const fetchUserByPhone = async (phone) => {
  try {
    const res = await axios.post("/admin/searchUserByPhone", { phone });

    if (res.data.msg === "success" && res.data.data) {
      const user = res.data.data;
      // 格式化用户数据
      return {
        id: user.id,
        phone: user.phone,
        username: user.username,
        password: user.password,
        invitation: user.invitation,
        points: Number(user.points || 0),
        vip: user.vip,
        vipTimeRaw: user.vip_time,
        currentMemberType: vipTypeMap[user.vip] || (Number(user.vip) > 0 ? '会员' : '非会员'),
        expireTime: user.vip_time ? dayjs(user.vip_time).format('YYYY-MM-DD HH:mm:ss') : '无',
        CreateTime: user.created_time ? dayjs(user.created_time).format('YYYY-MM-DD HH:mm') : '无'
      };
    } else if (res.data.msg === "error") {
      ElMessage.warning("查询错误：" + errorText(res.data.data, "用户查询失败"));
      return null;
    }
  } catch (error) {
    console.error("获取用户数据失败:", error);
    ElMessage.error("获取用户数据失败，请稍后重试");
    return null;
  }
};

// 查找用户
const searchUser = async () => {
  if (!searchForm.phone) {
    ElMessage.warning("请输入手机号");
    return;
  }

  searching.value = true;
  try {
    const user = await fetchUserByPhone(searchForm.phone);
    if (user) {
      userList.value = [user];
      ElMessage.success("用户查找成功");
    } else {
      userList.value = [];
    }
  } finally {
    searching.value = false;
  }
};

// 打开开通会员弹窗
const openMemberDialog = (user) => {
  currentUser.value = user;
  memberForm.phone = user.phone;
  memberForm.name = user.username || '未设置';
  memberForm.currentExpireTime = user.expireTime || "无";
  memberForm.days = 30;

  dialogVisible.value = true;
};

// 确认开通会员
const confirmOpenMember = () => {
  memberFormRef.value.validate(async (valid) => {
    if (!valid) return;

    try {
      const res = await axios.post("/admin/openVipMember", {
        phone: memberForm.phone,
        days: Number(memberForm.days)
      });
      console.log("开通结果:", res);

      if (res.data.msg === "success") {
        ElMessage.success(`会员已成功增加 ${memberForm.days} 天`);
        dialogVisible.value = false;

        // 开通成功后，重新从服务器获取最新用户数据
        const updatedUser = await fetchUserByPhone(memberForm.phone);
        if (updatedUser) {
          // 更新列表中的用户信息
          const index = userList.value.findIndex(item => item.phone === memberForm.phone);
          if (index !== -1) {
            userList.value[index] = updatedUser;
          }
        }
      } else {
        ElMessage.error("开通失败：" + errorText(res.data.data, res.data.msg));
      }
    } catch (error) {
      console.error("开通会员失败:", error);
      ElMessage.error("开通会员失败，请稍后重试");
    }
  });
};

// 打开修改密码弹窗
const openPwdDialog = (user) => {
  currentUser.value = user;
  pwdForm.phone = user.phone;
  pwdForm.newPwd = "";
  pwdForm.confirmPwd = "";

  pwdDialogVisible.value = true;
};

// 确认修改密码
const confirmUpdatePwd = () => {
  pwdFormRef.value.validate(async (valid) => {
    if (!valid) return;

    try {
      // 调用修改密码接口
      const res = await axios.post("/admin/setuserpwd", {
        phone: pwdForm.phone,
        password: pwdForm.newPwd
      });

      if (res.data.msg === "success") {
        ElMessage.success("密码修改成功");
        pwdDialogVisible.value = false;

        // 刷新用户数据
        const updatedUser = await fetchUserByPhone(pwdForm.phone);
        if (updatedUser) {
          const index = userList.value.findIndex(item => item.phone === pwdForm.phone);
          if (index !== -1) {
            userList.value[index] = updatedUser;
          }
        }
      } else {
        ElMessage.error("密码修改失败：" + (res.data.data || "服务器错误"));
      }
    } catch (error) {
      console.error("修改密码失败:", error);
      ElMessage.error("修改密码失败，请稍后重试");
    }
  });
};

// 打开修改邀请码弹窗
const openInviteDialog = (user) => {
  currentUser.value = user;
  inviteForm.phone = user.phone;
  inviteForm.oldInvite = user.invitation;
  inviteForm.newInvite = "";

  inviteDialogVisible.value = true;
};

// 确认修改邀请码
const confirmUpdateInvite = () => {
  inviteFormRef.value.validate(async (valid) => {
    if (!valid) return;

    // 确认修改提示
    try {
      await ElMessageBox.confirm(
        "确定要修改该用户的邀请码吗？修改后无法恢复！",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      );

      // 调用修改邀请码接口
      const res = await axios.post("/admin/updateInvitationCode", {
        phone: inviteForm.phone,
        newInvitation: inviteForm.newInvite
      });

      if (res.data.msg === "success") {
        ElMessage.success("邀请码修改成功");
        inviteDialogVisible.value = false;

        // 刷新用户数据
        const updatedUser = await fetchUserByPhone(inviteForm.phone);
        if (updatedUser) {
          const index = userList.value.findIndex(item => item.phone === inviteForm.phone);
          if (index !== -1) {
            userList.value[index] = updatedUser;
          }
        }
      } else {
        ElMessage.error("邀请码修改失败：" + (res.data.data || "服务器错误"));
      }
    } catch (error) {
      if (error !== "cancel") { // 排除取消操作的错误
        console.error("修改邀请码失败:", error);
        ElMessage.error("修改邀请码失败，请稍后重试");
      }
    }
  });
};

// 打开积分调整弹窗
const openPointsDialog = (user) => {
  currentUser.value = user;
  pointsForm.phone = user.phone;
  pointsForm.currentPoints = Number(user.points || 0);
  pointsForm.operation = "add";
  pointsForm.amount = 100;

  pointsDialogVisible.value = true;
};

// 确认充值/扣除积分
const confirmAdjustPoints = () => {
  pointsFormRef.value.validate(async (valid) => {
    if (!valid) return;

    try {
      if (pointsForm.operation === "deduct" && pointsAfterAdjustment.value < 0) {
        ElMessage.warning("扣除数量不能超过用户当前积分");
        return;
      }

      const actionName = pointsForm.operation === "deduct" ? "扣除" : "充值";
      await ElMessageBox.confirm(
        `确认给用户 ${pointsForm.phone} ${actionName} ${pointsForm.amount} 积分吗？`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      );

      const res = await axios.post("/admin/adjustUserPoints", {
        phone: pointsForm.phone,
        operation: pointsForm.operation,
        amount: Number(pointsForm.amount)
      });

      if (res.data.msg === "success") {
        ElMessage.success(`已成功${actionName} ${pointsForm.amount} 积分`);
        pointsDialogVisible.value = false;

        const updatedUser = await fetchUserByPhone(pointsForm.phone);
        if (updatedUser) {
          const index = userList.value.findIndex(item => item.phone === pointsForm.phone);
          if (index !== -1) {
            userList.value[index] = updatedUser;
          }
        }
      } else {
        ElMessage.error("积分调整失败：" + errorText(res.data.data, "服务器错误"));
      }
    } catch (error) {
      if (error !== "cancel") {
        console.error("积分调整失败:", error);
        ElMessage.error("积分调整失败，请稍后重试");
      }
    }
  });
};

</script>

<style scoped>
.member-container {
  padding: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 100px);
  color: #d9e4f2;
}

.member-card {
  --el-card-bg-color: rgba(13, 21, 34, 0.92);
  --el-card-border-color: #26364b;
  background: rgba(13, 21, 34, 0.92);
  border-color: #26364b;
  color: #d9e4f2;
  backdrop-filter: blur(14px);
}

.member-table {
  width: 100%;
  margin-bottom: 16px;
}

:deep(.member-card .el-card__body) {
  overflow: visible;
}

:deep(.member-table .el-table__fixed-right) {
  background: #0d1624;
}

.form-tip {
  width: 100%;
  margin-top: 6px;
  color: #7f91aa;
  font-size: 12px;
  line-height: 1.5;
}

:deep(.member-card .el-card__header) {
  color: #eef5ff;
  background: rgba(19, 30, 47, 0.78);
  border-bottom-color: #26364b;
}

:deep(.member-card .el-form-item__label) {
  color: #aebdd0;
}

:deep(.member-card .el-input__wrapper),
:deep(.member-card .el-select__wrapper),
:deep(.member-card .el-input-number .el-input__wrapper) {
  background: rgba(17, 27, 42, 0.9);
  box-shadow: 0 0 0 1px #31445e inset;
}

:deep(.member-card .el-input__inner) {
  color: #e7eef8;
}

:deep(.member-card .el-input.is-disabled .el-input__wrapper) {
  background: rgba(25, 36, 53, 0.7);
  box-shadow: 0 0 0 1px #2b3b51 inset;
}

:deep(.member-card .el-input.is-disabled .el-input__inner) {
  color: #8fa1b9;
  -webkit-text-fill-color: #8fa1b9;
}

:deep(.member-card .el-table) {
  --el-table-bg-color: transparent;
  --el-table-tr-bg-color: rgba(13, 22, 36, 0.86);
  --el-table-header-bg-color: #172438;
  --el-table-row-hover-bg-color: #1b2c43;
  --el-table-border-color: #2a3b52;
  --el-table-text-color: #c9d5e5;
  --el-table-header-text-color: #9fb0c6;
  background: transparent;
}

:deep(.member-card .el-table__inner-wrapper::before) {
  background-color: #2a3b52;
}

:deep(.el-radio-button__inner) {
  background: #121d2d;
  border-color: #31445e;
  color: #aebdd0;
  box-shadow: none;
}

:deep(.el-radio-button__original-radio:checked + .el-radio-button__inner) {
  background: #247fd1;
  border-color: #409eff;
  color: #fff;
  box-shadow: -1px 0 0 0 #409eff;
}
</style>
